export default __webpack_public_path__ + "static/media/danny-james.a7e6c842.webp";